import { render, staticRenderFns } from "./ProductGroupOrganizer.vue?vue&type=template&id=7d378ce4&scoped=true&"
import script from "./ProductGroupOrganizer.vue?vue&type=script&lang=ts&"
export * from "./ProductGroupOrganizer.vue?vue&type=script&lang=ts&"
import style0 from "./ProductGroupOrganizer.vue?vue&type=style&index=0&id=7d378ce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d378ce4",
  null
  
)

export default component.exports